import { SimpleChange } from '../../types/simple-change';

/** Util for checking if a change can be interpreted as an open or close */
export const getOpenStatus = (change?: SimpleChange<boolean>): [open: boolean, closed: boolean] => {
    const open = !!change?.currentValue && !change?.previousValue,
        closed = !change?.currentValue && !!change?.previousValue;

    return [open, closed];
};
